import { render, staticRenderFns } from "./NavigationHistory.vue?vue&type=template&id=098166bc&scoped=true&"
import script from "./NavigationHistory.vue?vue&type=script&lang=js&"
export * from "./NavigationHistory.vue?vue&type=script&lang=js&"
import style0 from "./NavigationHistory.vue?vue&type=style&index=0&id=098166bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098166bc",
  null
  
)

export default component.exports